import qrcode from "qrcode-generator";

import { isAppleDevice, isAndroidDevice } from "../utils";
import { appInstallUrl } from "../app-store-urls";

export default class Download {
  constructor() {
    const qr = qrcode("0", "L");

    qr.addData(appInstallUrl);
    qr.make();

    const image = qr.createImgTag(20);
    document.getElementById("download-qr-code").innerHTML = image;

    const imageEl = document
      .getElementById("download-qr-code")
      .querySelector("img");
    imageEl.classList.add("w-full");

    // DOM
    this.$links = document.querySelectorAll("[data-download]");
    this.$download = document.getElementById("download-modal");
    this.$closeBtn = this.$download.querySelector(".c-download__close");
    this.visibleClass = "is-visible";

    // Functions
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);

    // Events
    this.$links.forEach((link) => this.setupLink(link));
    this.$closeBtn.addEventListener("click", this.close);

    window.addEventListener("keyup", (e) => {
      if (e.keyCode === 27) this.close();
    });
  }

  /**
   * @function setupLink
   * @param {HTMLElement:any} link
   */
  setupLink(link) {
    link.addEventListener("click", this.open.bind(this));
    return this;
  }

  /**
   * @function open
   * @param {Event} e
   */
  open(e) {
    e.preventDefault();

    if (isAppleDevice() || isAndroidDevice()) {
      let storeLink = "";

      if (isAppleDevice()) {
        storeLink = window.site.meta.app_store;
      } else if (isAndroidDevice()) {
        storeLink = window.site.meta.play_store;
      }

      window.location = storeLink;

      return;
    }

    // Save the element that invoked the modal
    this.$invoker = e.target;
    this.$download.classList.add(this.visibleClass);
    this.$download.setAttribute("aria-hidden", false);

    // Focus on the modal
    setTimeout(() => {
      this.$download.focus();
    }, 500);
  }

  /**
   * @function close
   */
  close() {
    // Focus on the button/link that invoked the modal
    if (this.$invoker) {
      this.$invoker.focus();
    }

    this.$download.classList.remove(this.visibleClass);
    this.$download.setAttribute("aria-hidden", true);
  }
}
